import { render, staticRenderFns } from "./Management.vue?vue&type=template&id=a65f6e6e&scoped=true&"
import script from "./Management.vue?vue&type=script&lang=ts&"
export * from "./Management.vue?vue&type=script&lang=ts&"
import style0 from "./Management.vue?vue&type=style&index=0&id=a65f6e6e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65f6e6e",
  null
  
)

export default component.exports